import { render, staticRenderFns } from "./payrollRecords.vue?vue&type=template&id=57e28b8c&scoped=true"
import script from "./payrollRecords.vue?vue&type=script&lang=js"
export * from "./payrollRecords.vue?vue&type=script&lang=js"
import style0 from "./payrollRecords.vue?vue&type=style&index=0&id=57e28b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e28b8c",
  null
  
)

export default component.exports